import Select2Controller from '../select2_controller';
import $ from 'jquery';

export default class extends Select2Controller {
  async connect() {
    const connection = this.connection = {};
    // Keep the server-rendered selection usable if loading fails.
    super.connect();
    try {
      const { default: icons } = await import('virtual:fontawesome-free-icons');
      if (this.connection !== connection) return;
      this._populateOptions(icons);
      this.selectElement().trigger('change.select2');
    } catch (error) {
      console.error('Could not load the icon picker', error);
    }
  }

  disconnect() {
    this.connection = null;
    super.disconnect();
  }

  _populateOptions(icons) {
    const $select = this.selectElement();
    const existing = $select.val();

    $select.empty();
    $select.append(new Option('', '', false, false));

    for (const { id, text, prefix } of icons) {
      const label = `${text} (${prefix})`;
      const opt = new Option(label, id, false, id === existing);
      opt.dataset.prefix = prefix;
      $select.append(opt);
    }
  }

  defaultOptions() {
    return {
      ...super.defaultOptions(),
      multiple: false,
      placeholder: 'Search for an icon…',
      allowClear: true,
      templateResult: this._renderIconOption,
      templateSelection: this._renderIconSelection.bind(this)
    };
  }

  _renderIconOption(option) {
    if (!option.id) return option.text;
    return $(
      `<span class="d-flex align-items-center gap-2">
        <i class="${option.id}" style="width:1.25em;text-align:center"></i>
        <span>${option.text}</span>
      </span>`
    );
  }

  _renderIconSelection(option) {
    if (!option.id) return option.text;
    super.selectElement().value = option.id; // Ensure the select's value is updated
    return $(`<span><i class="${option.id} me-1"></i>${option.text}</span>`);
  }
}
